/* eslint-disable import/no-cycle */

import { FLOW_STEPS } from '../../constants';

import Welcome from '../Passwordless/Welcome';
import EmailLogIn from '../Passwordless/EmailLogIn';
import EmailSignUp from '../Passwordless/EmailSignUp';
import PasswordResetLink from '../Passwordless/PasswordResetLink';
import VerifyPhoneNumber from '../Passwordless/VerifyPhoneNumber';
import PhoneSignUp from '../Passwordless/PhoneSignUp';
import VerifyEmail from '../Passwordless/VerifyEmail';

export default {
  [FLOW_STEPS.WELCOME]: Welcome,
  [FLOW_STEPS.EMAIL_SIGNUP]: EmailSignUp,
  [FLOW_STEPS.EMAIL_LOGIN]: EmailLogIn,
  [FLOW_STEPS.PASSWORD_RESET_LINK]: PasswordResetLink,
  [FLOW_STEPS.VERIFY_PHONE_NUMBER]: VerifyPhoneNumber,
  [FLOW_STEPS.PHONE_SIGNUP]: PhoneSignUp,
  [FLOW_STEPS.VERIFY_EMAIL]: VerifyEmail,
};
